import { message } from 'antd';
import React from 'react';
import ChangeEmailForm from '@components/accounts/ChangeEmailForm';
import { AuthenticationStoreContext } from '@/stores/authentication.store';
import { removeFromStorage } from '@utils/storage.util';

interface ComponentProps {
  setChangeEmailModal?: any;
}

const ChangeEmailPage = (props: ComponentProps) => {
  const { setChangeEmailModal } = props;

  const authenticationStore = React.useContext(AuthenticationStoreContext);

  const handleChangeEmail = async (value: { email: string }) => {
    const result = await authenticationStore.changeEmail({
      newEmail: value.email,
    });

    if (result) {
      message.success('Please check your mail box!');
      removeFromStorage('token');
      authenticationStore.loggedUser = null;
    }
  };

  const handleCancel = () => {
    setChangeEmailModal(false);
  };

  return (
    <ChangeEmailForm
      handleChangeEmail={handleChangeEmail}
      handleCancel={handleCancel}
    />
  );
};

export default ChangeEmailPage;
